import { Pipe, PipeTransform, NgZone, ChangeDetectorRef } from '@angular/core';

@Pipe({
  name: 'amTimeAgo',
  pure: false, // allows real-time updates
})
export class AmTimeAgoPipe implements PipeTransform {
  private timer: any;

  constructor(
    private changeDetector: ChangeDetectorRef,
    private ngZone: NgZone
  ) {}

  transform(value: number | string | Date, suffix: boolean = true): string {
    if (!value) return '';

    // Convert to number (ms)
    let time = typeof value === 'number' ? value : new Date(value).getTime();

    // Handle timestamps in seconds → convert to ms
    if (time < 1000000000000) {
      time = time * 1000;
    }

    this.removeTimer();

    const now = Date.now();
    const seconds = Math.round((now - time) / 1000);

    const result = this.formatTime(seconds, suffix);

    // Auto-update every 30s
    this.ngZone.runOutsideAngular(() => {
      this.timer = setTimeout(() => {
        this.ngZone.run(() => this.changeDetector.markForCheck());
      }, 30000);
    });

    return result;
  }

  private formatTime(seconds: number, suffix: boolean): string {
    const intervals: any = {
      year: 31536000,
      month: 2592000,
      week: 604800,
      day: 86400,
      hour: 3600,
      minute: 60,
    };

    for (const key of Object.keys(intervals)) {
      const value = Math.floor(seconds / intervals[key]);
      if (value >= 1) {
        return `${value} ${key}${value > 1 ? 's' : ''}${suffix ? ' ' : ''} ago`;
      }
    }

    return 'Just now';
  }

  private removeTimer() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  }
}
